import { TFunction } from "i18next";

export enum MaintenanceControl {
  validateThermometer = "validateThermometer",
  validateDoorAndWindow = "validateDoorAndWindow",
  validateSewers = "validateSewers",
  validateCleaning = "validateCleaning",
  validatePests = "validatePests",
  validateWallAndFloor = "validateWallAndFloor",
}

export const MAINTENANCE_CONTROLS = (t: TFunction<"ns1", undefined>) => [
  {
    title: t("food.Food Temperature Mesaurement"),
    type: MaintenanceControl.validateThermometer,
    value: 1,
  },
  {
    title: t("food.Windows Control"),
    type: MaintenanceControl.validateDoorAndWindow,
    value: 1,
  },
  {
    title: t("food.Sewers Control"),
    type: MaintenanceControl.validateSewers,
    value: 1,
  },
  {
    title: t("food.Pest Control Yearly"),
    type: MaintenanceControl.validateCleaning,
    value: 1,
  },
  {
    title: t("food.Rust Free"),
    type: MaintenanceControl.validatePests,
    value: 1,
  },
  {
    title: t("food.Washable"),
    type: MaintenanceControl.validateWallAndFloor,
    value: 1,
  },
];
